import React from 'react'

const routes = [
  { // 首頁
    id: 'index', // 對應後端頁面權限 id
    path: '/index', // router 顯示的 url path
    exact: true, // 是否為嚴格匹配路徑
    component: React.lazy(() => import('../views/home')),
    name: 'Home', // 選單顯示的名稱, 對應語系檔的 key
    visible: true, // 是否顯示在選單上
    enable: true, // 是否在前端啟用
  },
  { // 查詢列表
    id: 'list', // 對應後端頁面權限 id
    path: '/list', // router 顯示的 url path
    exact: true, // 是否為嚴格匹配路徑
    component: React.lazy(() => import('../views/list')),
    name: 'List', // 選單顯示的名稱, 對應語系檔的 key
    visible: true, // 是否顯示在選單上
    enable: true, // 是否在前端啟用
  },
  { // 登入
    id: 'login',
    path: '/login',
    exact: true,
    component: React.lazy(() => import('../views/login')),
    name: 'Login',
    visible: true,
    enable: true,
  },
  { // callBack
    id: 'callback',
    path: '/callback',
    exact: true,
    component: React.lazy(() => import('../views/callback')),
    name: 'Callback',
    visible: true,
    enable: true,
  },
]
export default routes
